import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import AdminLogin from '../components/AdminLogin';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { isAdminAuthenticated } = useAdminAuth();

  useEffect(() => {
    if (isAdminAuthenticated) {
      navigate('/admin-setup');
    }
  }, [isAdminAuthenticated, navigate]);

  const handleLoginSuccess = () => {
    navigate('/admin-setup');
  };

  return <AdminLogin onLoginSuccess={handleLoginSuccess} />;
};

export default AdminLoginPage;
